// extracted by mini-css-extract-plugin
export default {"container":"Gvt_LN","text":"oiYYuj","visually-hidden":"XhFo3N","visuallyHidden":"XhFo3N"};